import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';

import { useSnackbar } from 'v3/components/Snackbar';
import Text from 'v3/components/Text';

import { cooperplaceApi } from 'services/api';

import { ImplementRegister as Register } from 'v3/pages/Wagons/Register';
import { ImplementDetails as Details } from '../Details';
import { format } from 'date-fns';
import moment from 'moment';
import { ImplementProvider } from './context';

export function ImplementShared() {
  const snackbar = useSnackbar();
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const currentImplementIdRef = useRef(params.id ?? null);

  const [implement, setImplement] = useState({
    city: null,
    plate: '',
    renavam: '',
    anttType: null,
    antt: '',
    rntrcExpDate: null,
    crlv: '',
    chassi: '',
    brand: null,
    model: null,
    yearModel: '',
    yearManufacture: '',
    color: null,
    totalGrossWeight: '',
    tareMass: '',
    cubage: '',
    vehicleType: null,
    bodyType: null,
    implementType: null,
    anttAdherence: null,
    rntrcValidated: false,
    owner: null,
    anttOwner: null,
    beneficiary: null,
    branchOffices: [],
  });
  const [prevImplement, setPrevImplement] = useState({});
  const [loading, setLoading] = useState(false);
 const [errors, setErrors] = useState({});

  function showSnackbar(text, options) {
    snackbar.show(<Text> {text} </Text>, options);
  }

  async function fetchImplement() {
    try {
      setLoading(true);
      const response = await cooperplaceApi.get(`wagons/${params.id}`);
      if (currentImplementIdRef.current !== params.id) {
        return;
      }
      let { data } = response;
      data = {
        ...data,
        color: { label: data?.color, value: data?.color },
        province: data?.plateState,
        city: {
          name: data?.plateCity,
          province: {
            uf: data?.plateState,
          },
        },
        brand: {
          id: data?.manufacturerId,
          name: data?.brand,
        },
        model: data?.model ? { label: data?.model } : null,
        anttType: { id: data?.anttTypes?.id, name: data?.anttTypes?.name },
        anttOwner: {
          label: data?.ownerAntt?.socialName,
          cpfCnpj: data?.ownerAntt?.cpfCnpj,
          id: data?.ownerAntt?.id,
          socialName: data?.ownerAntt?.socialName,
        },
        owner: {
          label: data?.ownerWagon?.socialName,
          cpfCnpj: data?.ownerWagon?.cpfCnpj,
          id: data?.ownerWagon?.id,
          socialName: data?.ownerWagon?.socialName,
        },
        beneficiary: {
          label: data?.beneficiaryWagon?.socialName,
          cpfCnpj: data?.beneficiaryWagon?.cpfCnpj,
          id: data?.beneficiaryWagon?.id,
          socialName: data?.beneficiaryWagon?.socialName,
        },
        anttAdherence: data?.anttAdherence
          ? format(new Date(moment(data?.anttAdherence).add(1, 'day')), 'yyyy-MM-dd')
          : null,
        bodyType: data?.bodyType,
      };
      setImplement(data);
      setPrevImplement(data);
      setLoading(false);
    } catch (error) {
      if (currentImplementIdRef.current !== params.id) {
        return;
      }
      showSnackbar('Não foi possível carregar esse implemento.', {
        type: 'error',
      });
      setLoading(false);
      navigate('/implementos');
    }
  }

  useEffect(() => {
    currentImplementIdRef.current = params.id ?? null;

    if (params.id) {
      fetchImplement();
      return;
    }

    setLoading(false);
    setImplement({
      city: null,
      plate: '',
      renavam: '',
      anttType: null,
      antt: '',
      rntrcExpDate: null,
      crlv: '',
      chassi: '',
      brand: null,
      model: null,
      yearModel: '',
      yearManufacture: '',
      color: null,
      totalGrossWeight: '',
      tareMass: '',
      cubage: '',
      vehicleType: null,
      bodyType: null,
      implementType: null,
      anttAdherence: null,
      rntrcValidated: false,
      owner: null,
      anttOwner: null,
      beneficiary: null,
      branchOffices: [],
    });
    setPrevImplement({});
    setErrors({});
  }, [params.id]);

  function setData(data) {
    setImplement((prev) => ({ ...prev, ...data }));
  }

  function updatePrevImplement(data) {
    setPrevImplement(data);
  }

  function handleCancel() {
    setImplement(prevImplement);
  }

  return (
    <ImplementProvider
      value={{
        data: implement,
        setData,
        loading,
        errors,
        setErrors,
        handleCancel,
        updatePrevImplement,
        showSnackbar,
        fetchImplement,
        prevImplement,
      }}
    >
      {params.id ? <Details key={params.id} /> : <Register key={location.key} />}
    </ImplementProvider>
  );
}
